<template>
  <!-- <el-row type="flex" justify="center" align="middle"> -->
  <el-row align="middle" justify="space-between">
    <el-col :span="12">
      <div class="title">赤峰市公务员平时考核系统</div>
    </el-col>
    <el-col :span="8" class="user_part">
      <!-- 提示消息 -->
      <div class="icon_group">
        <el-button type="text" @click="openMsg">
          <el-badge v-if="dotNotify" is-dot class="item">
            <el-icon class="btn">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1024 1024"
                data-v-394d1fd8=""
              >
                <path
                  fill="rgb(255, 255, 255)"
                  d="M640 832a128 128 0 0 1-256 0h256zm192-64H134.4a38.4 38.4 0 0 1 0-76.8H192V448c0-154.88 110.08-284.16 256.32-313.6a64 64 0 1 1 127.36 0A320.128 320.128 0 0 1 832 448v243.2h57.6a38.4 38.4 0 0 1 0 76.8H832z"
                ></path>
              </svg>
            </el-icon>
          </el-badge>
          <el-icon v-else class="btn">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1024 1024"
              data-v-394d1fd8=""
            >
              <path
                fill="rgb(255, 255, 255)"
                d="M640 832a128 128 0 0 1-256 0h256zm192-64H134.4a38.4 38.4 0 0 1 0-76.8H192V448c0-154.88 110.08-284.16 256.32-313.6a64 64 0 1 1 127.36 0A320.128 320.128 0 0 1 832 448v243.2h57.6a38.4 38.4 0 0 1 0 76.8H832z"
              ></path>
            </svg>
          </el-icon>
        </el-button>
      </div>

      <div style="width: 20px"></div>
      <!-- 坐标 -->
      <div class="icon_group">
        <el-icon>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1024 1024"
            data-v-394d1fd8=""
          >
            <path
              fill="rgb(255,255,255)"
              d="M512 928c23.936 0 117.504-68.352 192.064-153.152C803.456 661.888 864 535.808 864 416c0-189.632-155.84-320-352-320S160 226.368 160 416c0 120.32 60.544 246.4 159.936 359.232C394.432 859.84 488 928 512 928zm0-435.2a64 64 0 1 0 0-128 64 64 0 0 0 0 128zm0 140.8a204.8 204.8 0 1 1 0-409.6 204.8 204.8 0 0 1 0 409.6z"
            ></path>
          </svg>
        </el-icon>
        <div class="white_text">{{ regionName }}</div>
      </div>

      <div style="width: 20px"></div>
      <!-- 用户 -->
      <div class="icon_group">
        <el-dropdown trigger="click">
          <div class="el-dropdown-link">
            <el-icon>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1024 1024"
                data-v-394d1fd8=""
              >
                <path
                  fill="rgb(255,255,255)"
                  d="M628.736 528.896A416 416 0 0 1 928 928H96a415.872 415.872 0 0 1 299.264-399.104L512 704l116.736-175.104zM720 304a208 208 0 1 1-416 0 208 208 0 0 1 416 0z"
                ></path>
              </svg>
            </el-icon>
            <div class="white_text" style="user-select: none">
              {{ userName }}
            </div>
          </div>

          <template #dropdown>
            <el-card class="box-card">
              <template #header>
                <div class="card-header">
                  <el-avatar
                    :size="88"
                    :src="require('../assets/circleAva.png')"
                    style="pointer-events: none"
                  />
                  <h2>{{ userName }}</h2>
                  <h2>{{ departmentName }}</h2>
                </div>
              </template>
              <div class="card-btn-group">
                <el-button class="button" type="text" @click="doLogout"
                  >退出登录</el-button
                >
                <el-button class="button" type="text" @click="handleChangePwd"
                  >修改密码</el-button
                >
              </div>
            </el-card>
          </template>
        </el-dropdown>
      </div>

      <el-dialog v-model="showable.changePwdForm" title="修改密码" width="30%">
        <el-form>
          <el-form-item label="*旧密码">
            <el-input
              minlength="6"
              type="password"
              placeholder="请输入旧密码"
              v-model="changePwdForm.oldPassword"
            ></el-input>
          </el-form-item>
          <el-form-item label="*新密码">
            <el-input
              type="password"
              placeholder="请输入6位新密码"
              v-model="changePwdForm.newPassword"
            ></el-input>
          </el-form-item>
          <el-form-item label="*新密码">
            <el-input
              type="password"
              placeholder="请再次输入并确认你的新密码"
              v-model="changePwdForm.newPasswordAgain"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="bottom-btn">
          <el-popconfirm
            title="确认修改密码?"
            @confirm="doSubmit"
            confirm-button-text="是"
            cancel-button-text="否"
          >
            <template #reference>
              <el-button type="primary">确认</el-button>
            </template>
          </el-popconfirm>
          <el-button type="default" @click="doCancel">取消</el-button>
        </div>
      </el-dialog>
    </el-col>
  </el-row>
</template>


<script>
import HeadBar from "../api/HeadBar";
export default HeadBar;
</script>

<style scoped lang="scss">
.user_part {
  justify-content: right;
}
// class
.title {
  color: rgb(209, 214, 219);
  font-size: 25px;
  height: 100%;
  user-select: none;
}

.el-row {
  // display: flex;
  align-self: center;
  height: 100%;
}

.icon_group {
  display: flex;
  align-items: center;
  margin-right: 10px;
}

// 标签
.el-col {
  display: flex;
  // align-items: center;
}

.white_text {
  color: white;
  user-select: none;
}

.el-badge {
  margin: 0;
  padding: 0;
}

.el-icon {
  font-size: 28px;
}

.el-dropdown-link {
  display: flex;
  align-items: center;
}

.box-card {
  width: 280px;
  user-select: none;
}

.card-header {
  text-align: center;
  margin-right: 0px;
}

.card-btn-group {
  text-align: center;
}

.bottom-btn {
  text-align: end;
}
</style>
